import React, { useContext } from 'react';
import proptypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Loader } from '@thd-olt-component-react/core-ui';
import { Carousel } from '@one-thd/sui-carousel';
import { phpDataModel } from '../dataModel';
import { InformationAndCtaPod } from '../information-and-cta-pod/InformationAndCtaPod';
import { dataStore } from '../../php-card-matrix';

const { string, bool } = proptypes;

export const HomeServicePhpCarousel = ({ enableRoundedImages }) => {
  // for development
  // gets the user cookie
  const THDCustomer = typeof window !== 'undefined' ? window.THDCustomer?.default : {};
  const userId = THDCustomer?.svocID || THDCustomer?.userID || THDCustomer?.guestUserID;
  const { channel } = useContext(ExperienceContext) || {};
  const udsQuery = {
    variables: {
      userId,
      appId: channel === 'mobile' ? 'mobileweb' : 'desktop',
      apiName: 'homeservices',
      key: 'aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee',
    },
    ssr: false,
  };
  const { loading, data } = useDataModel('uds', udsQuery);
  if (loading) {
    return (
      <div>
        <Loader className="sui-top-36 sui-left-36" active />
      </div>
    );
  }
  const carouselContent = data?.uds?.services
    ?.filter((service) => service && dataStore[service?.id])
    ?.map((service, index) => {
      return (
        <div key={service?.id}>
          <InformationAndCtaPod
            service={dataStore[service?.id]}
            id={service?.id}
            position={index + 1}
            enableRoundedImages={enableRoundedImages}
          />
        </div>
      );
    });

  const carouselPreview = {
    slidesPerView: 1,
    slidesPerGroup: 1,
  };

  return (
    <div>
      {carouselContent && carouselContent.length > 0 ? (
        <Carousel
          breakpoints={{
            sm: carouselPreview,
            md: carouselPreview,
            lg: carouselPreview,
            xl: carouselPreview,
          }}
          slidesPerGroup={1}
          slidesPerView={1}
          disableShadow
          disableMargin
        >
          {carouselContent}
        </Carousel>
      ) : (
        <div>
          <InformationAndCtaPod 
            enableRoundedImages={enableRoundedImages} 
            service={dataStore.GENERIC} 
            id="GENERIC" 
          />
        </div>
      )}
    </div>
  );
};
HomeServicePhpCarousel.dataModel = phpDataModel;

HomeServicePhpCarousel.propTypes = {
  enableRoundedImages: bool,
};

HomeServicePhpCarousel.defaultProps = {
  enableRoundedImages: false,
};

HomeServicePhpCarousel.displayName = 'HomeServicePhpCarousel';
